// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner-mochi_spinner___FOEn","placeHolderShimmer":"spinner-mochi_placeHolderShimmer__67SAk"};